/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { SectionFragmentDto } from "../SectionFragmentDto";

export class RoofTrimDto extends SectionFragmentDto {

}
